


















































































import { Component, Vue } from 'vue-property-decorator'
import { ACCOUNT_PROFILE_ADMIN, ACCOUNT_PROFILE_MANAGER, ROLE_ADMIN, ROLE_READ } from '@/utils/constants'

@Component({
  components: {
    UserMenuDropdown: () => import('@/containers/UserMenuDropdown.vue'),
    ProductSearchHeader: () => import('@/containers/ProductSearchHeader.vue'),
    TypeIcon: () => import('@/components/TypeIcon.vue')
  }
})
export default class Header extends Vue {
  public ROLE_ADMIN = ROLE_ADMIN
  public USERS_MODULE_PROFILES = [ACCOUNT_PROFILE_ADMIN, ACCOUNT_PROFILE_MANAGER]
  private pages = [
    { title: 'header_container.editorial_projects', link: '/editorial-project', role: ROLE_READ },
    { title: 'header_container.products', link: '/product', role: ROLE_READ },
    { title: 'header_container.tracing', link: '/tracing', role: ROLE_READ }
  ]

  private usersPages: Array<{ title?: string; link?: string; profiles?: string[]; divider?: boolean }> = [
    { title: 'header_container.accounts', link: '/accounts', profiles: [ACCOUNT_PROFILE_ADMIN, ACCOUNT_PROFILE_MANAGER] },
    { title: 'header_container.teams', link: '/teams', profiles: [ACCOUNT_PROFILE_ADMIN] },
    { title: 'header_container.providers', link: '/providers', profiles: [ACCOUNT_PROFILE_ADMIN] },
    { title: 'header_container.buildings', link: '/buildings', profiles: [ACCOUNT_PROFILE_ADMIN] },
    { title: 'header_container.business_units', link: '/business-units', profiles: [ACCOUNT_PROFILE_ADMIN] },
    { title: 'header_container.companies', link: '/companies', profiles: [ACCOUNT_PROFILE_ADMIN] },
    { title: 'header_container.account_metadata_fields', link: '/account-metadata-fields', profiles: [ACCOUNT_PROFILE_ADMIN] },
    { title: 'header_container.apps', link: '/apps', profiles: [ACCOUNT_PROFILE_ADMIN] },
    { title: 'header_container.resources', link: '/resources', profiles: [ACCOUNT_PROFILE_ADMIN] }
  ]

  private adminPages: Array<{ title?: string; link?: string; role?: string; divider?: boolean }> = [
    { title: 'header_container.project', link: '/project', role: ROLE_ADMIN },
    { title: 'header_container.node_template', link: '/template', role: ROLE_ADMIN },
    { title: 'header_container.tools', link: '/tools', role: ROLE_ADMIN },
    { title: 'header_container.element_type', link: '/element-type', role: ROLE_ADMIN },
    { title: 'header_container.controlled_vocabulary', link: '/controlled-vocabulary', role: ROLE_ADMIN },
    { title: 'header_container.production_preps', link: '/production-preps', role: ROLE_ADMIN }
  ]

  private toolsLinks = [
    {
      title: 'WoodWing Global',
      titleHover: `${this.$t('header_container.tools_links.ww_title')}`,
      icon: 'ti-woodwing-butterfly',
      link: `${process.env.VUE_APP_WOODWING_URL}`
    },
    {
      title: 'Funbox',
      titleHover: `${this.$t('header_container.tools_links.funbox_title')}`,
      icon: 'ti-funbox',
      link: `${process.env.VUE_APP_FUNBOX_URL}`
    },
    {
      title: 'Superset',
      titleHover: `${this.$t('header_container.tools_links.superset_title')}`,
      icon: 'ti-superset',
      link: `${process.env.VUE_APP_SUPERSET_URL}`
    },
    {
      title: 'Assets',
      titleHover: `${this.$t('header_container.tools_links.assets_title')}`,
      icon: 'ti-assets',
      link: `${process.env.VUE_APP_ASSETS_URL}`
    },
    {
      title: 'LDX',
      titleHover: `${this.$t('header_container.tools_links.ldx_title')}`,
      icon: 'ti-ldx',
      link: `${process.env.VUE_APP_LDX_URL}`
    }
  ]
}
